import React from "react";
import { chakra, Text, HStack, Icon, useBreakpointValue } from "@chakra-ui/react";
import { FaClock } from "react-icons/fa";

const Index = () => {
  const [time, setTime] = React.useState(new Date());

  // Chakra UI responsive breakpoints
  const _isCurrentViewMobile = useBreakpointValue(
    { base: true, lg: false },
    { fallback: "base" },
  ) ?? true;

  // Update time only when minute changes
  React.useEffect(() => {
    const now = new Date();
    const delay = (60 - now.getSeconds()) * 1000;

    const timeout = setTimeout(() => {
      setTime(new Date());
    }, delay);

    return () => clearTimeout(timeout);
  }, [time]);

  // Format time: hour + minute only
  const formattedTime = React.useMemo(() => {
    return time.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    }).toUpperCase();
  }, [time]);

  // Format date
  const formattedDate = React.useMemo(() => {
    return time.toUTCString().split(" ").slice(0, 3).join(" ");
  }, [time]);

  return (
    <HStack
      spacing={{ base: 1, lg: 2 }}
      color="#FFF"
      position="relative"
      borderRadius="md"
      minW={{ base: "auto", lg: "220px" }}
      justify="center"
      whiteSpace="nowrap"
      overflow="hidden"
    >
      {!_isCurrentViewMobile && (
        <>
          <Text
            fontSize="23px"
            fontWeight="240"
            fontFamily="DM Sans"
          >
            {formattedDate}
          </Text>

          <Text
            fontSize="23px"
            fontWeight="240"
            whiteSpace="nowrap"
            fontFamily="DM Sans"
          >
            <Icon as={FaClock} boxSize={{ base: 5, md: 4, lg: 5 }} mr={1} />
            <chakra.span>{formattedTime}</chakra.span>
            <chakra.span ml={1.5}>UTC (+00:00)</chakra.span>
          </Text>
        </>
      )}
    </HStack>
  );
};

export default React.memo(Index);
